// src/pages/QualityAssurance.js
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Button from '../components/ui/Button';
import ProductCard from '../components/ui/ProductCard';
import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import quality from '../assets/images/category/uncompremasing quality.jpg';
import { Link } from 'react-router-dom';

const QualityAssurance = () => {
  const relatedCategories = [
    {
      title: "Bread Improvers & Dough Conditioners",
      description: "Premium improver systems.",
      itemCount: 12,
      image:image2,
      link: "/products/bread-improvers"
    },
    {
      title: "Premixes & Concentrates",
      description: "Ready solutions.",
      itemCount: 14,
      image: image3,
      link: "/products/premixes"
    },
    {
      title: "Shelf-Life Enhancers & Preservatives",
      description: "Freshness guaranteed.",
      itemCount: 10,
      image: image4,
      link: "/products/shelf-life"
    },
    {
      title: "Emulsifiers & Texture Improvers",
      description: "Texture perfection.",
      itemCount: 8,
      image:image5,
      link: "/products/emulsifiers"
    },
    {
      title: "Leavening Agents (Raising Agents)",
      description: "Perfect rise.",
      itemCount: 13,
      image: image6,
      link: "/products/leavening"
    },
    {
      title: "Specialty Enzymes",
      description: "Natural solutions.",
      itemCount: 17,
      image: image7,
      link: "/products/enzymes"
    },
    {
      title: "Other Ingredients: Starches, Gums, Flavors",
      description: "Specialty ingredients.",
      itemCount: 20,
      image: image8,
      link: "/products/other-ingredients"
    },
    {
      title: "View All Products",
      description: "Complete range.",
      itemCount: null,
      image: image9,
      link: "/products"
    }
  ];

  return (
    <div className="min-h-screen bg-cream">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Hero Image */}
            <div className="flex-1 max-w-xl">
              <img 
                src={quality} 
                alt="Quality Assurance"
                className="rounded-3xl shadow-xl w-full object-cover"
              />
            </div>

            {/* Text Content */}
            <div className="flex-1 max-w-xl">
              <div className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
                Quality Statement
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-brown mb-6 leading-tight">
                Uncompromising Quality.<br/>Every Batch. Every Time.
              </h1>
              <p className="text-brown-light mb-6 text-lg leading-relaxed">
                Enessa Foods stands on a solid foundation of quality, professionalism and quality ingredients—backed by world-class support.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/contact"><Button variant="primary" icon="→">Contact Us</Button></Link>
                <Link to="/products#products-category"><Button variant="secondary" icon="→">View Catalog</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Pillars */}
      <section className="py-16 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            {/* Rigorous Quality Checks */}
            <div className="bg-white rounded-3xl p-8 shadow-soft">
              <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-primary" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-brown mb-4">Rigorous Quality Checks</h3>
              <p className="text-brown-light leading-relaxed">
                All formulations go through strict microbiological, physical, and sensory evaluations to guarantee safety and regulatory compliance at every step of the way.
              </p>
            </div>

            {/* Reliable Consistency */}
            <div className="bg-white rounded-3xl p-8 shadow-soft">
              <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-primary" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-brown mb-4">Reliable Consistency</h3>
              <p className="text-brown-light leading-relaxed">
                Lot-to-lot product performance stays uniform, helping you standardize production while reducing variability. You can trust us to deliver the same level of quality batch after batch.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Enessa Advantage */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
              Our Commitment
            </div>
            <h2 className="text-3xl font-bold text-brown mb-4">
              The Enessa Advantage
            </h2>
            <p className="text-brown-light max-w-3xl mx-auto">
              When you choose our products, you're not just buying ingredients – you're securing a partnership focused on growing your business.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Strategic Stocking",
                subtitle: "Ready Supply",
                description: "We keep critical raw materials and ingredient formulations in stock so you can scale up or launch new products quickly—cutting lead times down and keeping your operations agile."
              },
              {
                title: "Launch New Products Swiftly",
                subtitle: "Faster Time to Market",
                description: "Our technical support and ready-to-use formulations let you fast-track new product launches. Get to market ahead of the competition with tried-and-tested solutions."
              },
              {
                title: "Solve Production Challenges",
                subtitle: "Technical Support",
                description: "Whether you're scaling up production or solving a technical challenge, our experienced team provides immediate help with ingredient selection, dosage optimization, and process tweaks—cutting downtime right away."
              },
              {
                title: "Detailed Product Specifications",
                subtitle: "Complete Transparency",
                description: "We provide in-depth specs for each product, including usage guidelines, regulatory details, and application insights. You get the clarity to make the right choice every time."
              },
              {
                title: "Recipe Guidance & Optimization",
                subtitle: "Expert Support",
                description: "Need to tweak a formulation or standardize a new recipe? We help you optimize your recipes and ingredient usage—reducing trial-and-error and maximizing quality. Our application experts are ready to assist."
              },
              {
                title: "Troubleshooting Made Easy",
                subtitle: "Problem Solving",
                description: "Run into an issue with dough stickiness or oven spring? We diagnose the problem quickly and provide practical solutions that minimize waste, downtime, and frustration—keeping your production line running smoothly."
              }
            ].map((item, idx) => (
              <div key={idx} className="bg-cream rounded-2xl p-6">
                <div className="text-xs font-semibold text-primary mb-2 uppercase tracking-wide">
                  {item.subtitle}
                </div>
                <h4 className="text-xl font-bold text-brown mb-3">{item.title}</h4>
                <p className="text-brown-light text-sm leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trusted Expertise Section */}
      <section className="py-16 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 text-center mb-16">
            {[
              {
                icon: "📋",
                title: "Detailed Product Specifications",
                description: "We deliver exactly what your batch needs—and nothing you don't. Every order includes transparent specs, batch info, and regulatory details."
              },
              {
                icon: "👨‍🍳",
                title: "Recipe Guidance & Optimization",
                description: "Need to tweak a recipe or standardize output? Our experts help you optimize formulations to reduce trial-and-error and maximize quality."
              },
              {
                icon: "🔧",
                title: "Troubleshooting Made Easy",
                description: "From dough stickiness to oven spring—we diagnose the problem quickly and provide practical, real-world solutions that work."
              }
            ].map((item, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-8 shadow-soft">
                <div className="text-5xl mb-4">{item.icon}</div>
                <h4 className="text-xl font-bold text-brown mb-3">{item.title}</h4>
                <p className="text-brown-light text-sm leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
              Product Categories
            </div>
            <h2 className="text-3xl font-bold text-brown mb-4">
              Explore Our Product Portfolio
            </h2>
            <p className="text-brown-light max-w-3xl mx-auto">
              An overview of our specialized categories—crafted to meet every baker's need with performance and precision.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {relatedCategories.map((category, index) => (
              <ProductCard
                key={index}
                title={category.title}
                description={category.description}
                itemCount={category.itemCount}
                image={category.image}
                link={category.link}
                category="PRODUCT CATEGORY"
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-cream">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="bg-white rounded-3xl shadow-soft p-8 lg:p-12 text-center">
            <h3 className="text-3xl font-bold text-brown mb-4">
              Built On Trust. Grows In Proximity.
            </h3>
            <p className="text-brown-light mb-6 max-w-3xl mx-auto leading-relaxed">
              From helping you formulate your first artisan loaf to scaling industrial bread lines, Enessa is here for you. We believe in long-term partnerships that grow based on trust, proximity and consistent results.
            </p>
            <div className="flex justify-center gap-4">
              <Link to="/contact"><Button variant="primary" icon="→">Contact Us</Button></Link>
                <Link to="/products#products-category"><Button variant="secondary" icon="→">Enquiry Form</Button></Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default QualityAssurance;